import Plyr from 'plyr/src/js/plyr';

Array.from(document.body.querySelectorAll('.content-video-plyr')).forEach(element => {
	let player = new Plyr(element, {
		// controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
	});

	player.on('playing', event => {
		element.parentNode.classList.add('content-video-is-playing');
	});

	player.on('ended', event => {
		element.parentNode.classList.remove('content-video-is-playing');
	});
});
